(ns ycweb.app.website.products.components.variation-list
  (:require
   [rum.core :as rum]
   [api.products.helpers :as product-helpers]
   [ycweb.components.common :as cmn]
   [ycweb.util.core :as u]
   [util.string :as str]))

(defn open-variation-list [process-atom]
  (swap! process-atom assoc :variation-list-open? true)
  #?(:cljs
     (.add (.-classList (.-body js/document)) "body--no-scroll")
     :clj nil))

(defn close-variation-list [process-atom]
  (swap! process-atom assoc :variation-list-open? false)
  #?(:cljs
     (.remove (.-classList (.-body js/document)) "body--no-scroll")
     :clj nil))

(defn- cloudinary-url [{:keys [public-id width height]}]
  (str "https://res.cloudinary.com/yuppiechef/image/upload/"
    (when (and width height) (str "c_lpad,dpr_2,e_sharpen:40,f_auto,h_" height ",q_auto,w_" width "/"))
    "v1/" public-id))

(defn variation-query-string
  "?id=<id>&name=<slug>&vid=<vid> — name slug matches PHP's insert_queryurl,
   omitted when the product name is blank."
  [product variation-id]
  (let [slug (some-> (:name product) str/trim u/presence product-helpers/query-url)]
    (str "?id=" (:id product)
      (when slug (str "&name=" slug))
      "&vid=" variation-id)))

(defn- variation-url [product varoption]
  (let [base-path
        (or
          (:page-url product)
          (when (u/presence (:url product))
            (str "/" (:url product) ".htm"))
          #?(:cljs (.-pathname js/window.location)
             :clj ".htm"))]
    (str base-path (variation-query-string product (:variation/id varoption)))))

(defn- variation-feature-name [varoption]
  (cond
    (not (str/blank? (:variation/feature1 varoption))) (:variation/feature1 varoption)
    (not (str/blank? (:variation/feature2 varoption))) (:variation/feature2 varoption)
    (not (str/blank? (:variation/feature3 varoption))) (:variation/feature3 varoption)
    :else ""))

(defn- colour-mode? [variation]
  (not (str/blank? (:variation/feature2 variation))))

(rum/defc variation-list-stock-status < rum/static [varoption]
  (let [{:variation/keys [stockmessage]} varoption
        {:stock/keys [availability availability2 availability-class]} stockmessage
        avail-class (or availability-class "info")]
    (when (and stockmessage (u/presence availability))
      [:span
       {:class (str "var-list__status var-list__status--" avail-class)}
       [:span.u-hidden-from-view "Availability: "]
       [:span.var-list__status-text
        [:span availability]
        (when
          (and
            (not= avail-class "out-of-stock")
            (u/presence availability2))
          [:span " " availability2])]])))

(rum/defc variation-list-item < rum/static [product varoption current-variation-id on-select]
  (let [is-active? (= (:variation/id varoption) current-variation-id)
        {:variation/keys [price price-was image variation-special]} varoption
        new? (:variation/new varoption)
        has-was-price? (and price-was price (> price-was price))
        feature-name (variation-feature-name varoption)
        content-name (:product/content-name product)
        alt-text (str content-name " - " feature-name)]
    [:li {:class (str "var-list__item" (when is-active? " var-list__item--is-active"))}
     [:a.var-list__link
      {:href (variation-url product varoption)
       :on-click
       (fn [e]
         (.preventDefault e)
         (on-select (:variation/id varoption)))}
      [:div.var-list__sku
       [:div.var-list__hero
        (when (:doc/public-id image)
          [:img.yc-simple-image.yc-simple-image--full
           {:src (cloudinary-url {:public-id (:doc/public-id image) :width 96 :height 96})
            :alt alt-text
            :width "48" :height "48"}])]
       [:div.var-list__text
        [:span.var-list__title feature-name]
        [:span.u-hidden-from-view " | Price: "]
        [:span.var-list__price
         (if has-was-price?
           (list
             [:span.var-list-price__now {:key "now"}
              [:span.u-hidden-from-view "Now: "]
              (str "R" (u/number-format price))]
             [:span.var-list-price__was {:key "was"}
              [:span.u-hidden-from-view " | Was: "]
              (str "R" (u/number-format price-was))])
           [:span (str "R" (u/number-format price))])]]
       [:div.var-list__icon-wrapper
        (if is-active?
          [:i.var-list__icon.icon.icon--block.icon--default.icon--is-dark.icon--success]
          [:i.var-list__icon.icon.icon--block.icon--default.icon--is-dark.icon--arrow-right])]]
      (variation-list-stock-status varoption)
      (when new?
        [:span.var-list__text-pill.text-pill.text-pill--dark.u-text-uppercase "New"])
      (when-let [shortdesc (:special/short-desc variation-special)]
        (when (u/presence shortdesc)
          [:div.var-list__special
           [:span.text-pill.text-pill--tiny.text-pill--sale.u-text-uppercase
            shortdesc
            (when-let [amount (:special/amount-desc variation-special)]
              (str " R" (u/number-format amount)))]]))]]))

(rum/defc variation-list-modal < rum/reactive [process-atom product variation on-select]
  (let [is-open? (cmn/curact process-atom :variation-list-open?)
        variations
        (if-let [order (:product/variation-order product)]
          (keep #(get (:variations product) %) order)
          (vals (:variations product)))
        current-variation-id (:variation/id variation)
        colour? (colour-mode? variation)]
    [:div.var-list-wrapper
     [:div
      {:class
       (str "var-list-overlay"
         (when is-open? " var-list-overlay--is-open"))
       :on-click #(close-variation-list process-atom)}]
     [:nav
      {:class
       (str "var-list-modal"
         (when is-open? " var-list-modal--is-open"))}
      [:header.var-list-modal__header
       [:h2.var-list-modal__heading
        [:span "Choose a "]
        (if colour?
          [:span "colour"]
          [:span "variant"])]
       [:a.var-list-modal__close-button.button.button--default.button--has-icon-only.button--secondary.button--circle
        {:href "#"
         :on-click
         (fn [e]
           (.preventDefault e)
           (close-variation-list process-atom))}
        [:span.button__text
         [:i.button__icon.icon.icon--block.icon--is-dark.icon--close]
         [:span.u-hidden-from-view "Close variant options"]]]]
      ;; Render the list only when open to avoid SSR hydration mismatch.
      [:div.var-list-modal__content
       [:p.var-list-modal__description (:product/content-name product)]
       (when is-open?
         [:ul.var-list
          (for [varoption variations]
            (rum/with-key
              (variation-list-item product varoption current-variation-id on-select)
              (:variation/id varoption)))])]]]))
